import script from "./ElevateLicences.vue?vue&type=script&setup=true&lang=js"
export * from "./ElevateLicences.vue?vue&type=script&setup=true&lang=js"

import "./ElevateLicences.vue?vue&type=style&index=0&id=0929cc49&lang=css"

const __exports__ = script;

export default __exports__